

















































































import { Component, Vue, Prop, Emit, Inject } from 'vue-property-decorator';
import { CustomField, CustomFieldValue, CustomFieldType, createCustomField, CustomerType } from '../../common/types/AllTypesExports';
import CustomFieldTextEditor from './CustomFieldTextEditor.vue';
import CustomFieldCheckboxEditor from './CustomFieldCheckboxEditor.vue';
import CustomFieldNumberEditor from './CustomFieldNumberEditor.vue';
import CustomFieldSetOfOptionsEditor from './CustomFieldSetOfOptionsEditor.vue';
import CustomFieldDateTimeEditor from './CustomFieldDateTimeEditor.vue';
import CustomFieldWebsiteURLEditor from './CustomFieldWebsiteURLEditor.vue';
import CustomFieldFileUploadEditor from './CustomFieldFileUploadEditor.vue';
import EventBus from '@/common/services/EventBus';

@Component({
  components: {
      CustomFieldTextEditor,
      CustomFieldCheckboxEditor,
      CustomFieldNumberEditor,
      CustomFieldSetOfOptionsEditor,
      CustomFieldDateTimeEditor,
      CustomFieldWebsiteURLEditor,
      CustomFieldFileUploadEditor
  },
})
export default class CustomFieldEditor extends Vue {
    //External
    @Prop({required: true, default: () => createCustomField()})
    fieldConfig!: CustomField;

    @Prop({ required: false, default: "" })
    idPrefix?: string;

    @Prop({default: function() { return {value: "", isSummation: false} }})
    value!: CustomFieldValue;

    @Prop()
    columnClass?: string;

    @Prop({required: false, default: ''})
    validatorScope!: string;

    @Prop({ required: false, default: false })
    disabled!: boolean;

    @Prop({ required: false, default: false })
    hideDisabledMessage!: boolean;

    @Prop({ required: false, default: null })
    isRequired!: boolean;

    @Prop({ required: false, default: CustomerType.Person })
    customerType!: CustomerType;

    @Inject('validator')
    $validator: any;

    //Internal
    customFieldTypes: object = CustomFieldType;
    hasValueOnLoad: boolean = false;

    //Functions
    created() {
        this.value.customFieldId = this.fieldConfig.id;

        // Keep original value for logic below
        const original = this.value ? this.value.value : undefined;

        if (this.fieldConfig.customFieldType === CustomFieldType.Checkbox) {
            // Decide hasValueOnLoad BEFORE setting default
            // Treat only explicit "true" as "had initial value" to avoid locking on default false
            let hadTrue = false;
            if (typeof original === "string") {
                const s = original.toLowerCase();
                hadTrue = (s === "true" || s === "1" || s === "yes" || s === "on");
            } else if (typeof original === "boolean") {
                hadTrue = original === true;
            } else if (typeof original === "number") {
                hadTrue = original === 1;
            }
            this.hasValueOnLoad = hadTrue;

            // Normalize & set default for checkbox (keep value as string)
            if (original === undefined || original === null || original === "") {
                this.value.value = "false";
            } else if (typeof original === "string") {
                const s = original.toLowerCase();
                this.value.value = (s === "true" || s === "1" || s === "yes" || s === "on") ? "true" : "false";
            } else if (typeof original === "boolean") {
                this.value.value = original ? "true" : "false";
            } else if (typeof original === "number") {
                this.value.value = original === 1 ? "true" : "false";
            }
        } else {
            // Non-checkbox: consider non-empty string or any number as "had value"
            if (typeof original === "string" && original.length > 0) {
                this.hasValueOnLoad = true;
            } else if (typeof original === "number") {
                this.hasValueOnLoad = true;
            } else {
                this.hasValueOnLoad = false;
            }
        }

        this.emitInput();

        EventBus.$on("attendee-selector-change", this.emitInput);
    }

    @Emit('input')
    emitInput() {
        this.$forceUpdate();
        return this.value;
    }

    get readOnly() {
        // Although fieldConfig is currently not used on frontend we are extending the condition so that we prevent any potential problems in the future
        return this.fieldConfig.readOnlyOnFrontend || (this.fieldConfig.readOnlyAfterInitialValue && this.hasValueOnLoad) || this.disabled;
    }

    get computedId() {
        return this.idPrefix + 'CustomField_' + this.fieldConfig.id;
    }
}
